export var ACTION;
(function (ACTION) {
    ACTION["AUTO_FETCH_MY_PORTFOLIO"] = "AUTO_FETCH_MY_PORTFOLIO";
    ACTION["FETCH_MY_PORTFOLIO"] = "FETCH_MY_PORTFOLIO";
    ACTION["EDIT_PAN"] = "EDIT_PAN";
    ACTION["EDIT_MOBILE_NUMBER"] = "EDIT_MOBILE_NUMBER";
    ACTION["Go_BACK"] = "Go_BACK";
    ACTION["SELECT_SOURCE"] = "SELECT_SOURCE";
    ACTION["GO_BACK_MANAGE_LIMIT"] = "GO_BACK_MANAGE_LIMIT";
    ACTION["NEED_HELP"] = "NEED_HELP";
    ACTION["GO_HOME"] = "GO_HOME";
    ACTION["CLOSE_POPUP"] = "CLOSE_POPUP";
    ACTION["EDIT_DETAILS"] = "EDIT_DETAILS";
    ACTION["CONTACT_US"] = "CONTACT_US";
    ACTION["MODAL_CLOSE"] = "MODAL_CLOSE";
    ACTION["EDIT_DETAILS_ERROR"] = "EDIT_DETAILS_ERROR";
})(ACTION || (ACTION = {}));
